
export default {
	data() {
		return {
			optionsPadronizadas: [
				{ label: "Todos", value: "", id: 0 },
				{ label: "Ações", value: "Ações", id: 1 },
				{ label: "FIIs", value: "FII - Fundo de Investimento Imobiliário", id: 2 },
				{ label: "Stocks", value: "Stock", id: 3 },
				{ label: "REIT", value: "REIT", id: 4 },
				{ label: "ETFs", value: "ETF - Exchange Traded Fund", id: 5 },
				{ label: "Renda fixa", value: "TesouroDireto", id: 6 },
				

			],
			isMobile: false,
			tipo_ativo: '',
			baseURL: window.location.origin,
			GLOBAL: GLOBAL,

		}
	},




	mounted() {
		this.setInitialValueOnSelectFromURL();

		// Verificando se a tela é móvel no momento do carregamento
		this.checkIfMobile();
		// Adicionando um listener para verificar quando a janela for redimensionada
		window.addEventListener('resize', this.checkIfMobile);
	},

	beforeDestroy() {
		// Certifique-se de remover o listener quando o componente for destruído
		window.removeEventListener('resize', this.checkIfMobile);
	},


	methods: {

		setInitialValueOnSelectFromURL() {
			const urlParams = new URLSearchParams(window.location.search);
			const tipoURL = urlParams.get('tipos_investimento');
			this.tipo_ativo = tipoURL;
		},
		submitFormOnChange(opcaoSelecionada) {
			const form = this.$refs.form_home;
			this.tipo_ativo = opcaoSelecionada.value
			setTimeout(() => {
				form.submit()
			}, 500)

		},

		checkIfMobile() {
      this.isMobile = window.innerWidth < 1180;
    }
	},
	delimiters: ["{*", "*}"], //delimitadores pra n conflitar com o django
}